<template>
  <div class="provider-card-skeleton">
    <div class="skeleton-image"></div>
    <div class="skeleton-content">
      <div class="skeleton-info">
        <div class="skeleton-category"></div>
      </div>
      <div class="skeleton-title"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProviderCardSkeleton"
}
</script>

<style scoped>
.provider-card-skeleton {
  display: block;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  height: 100%;
}

.skeleton-image {
  width: 100%;
  height: 160px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

.skeleton-content {
  padding: 12px;
}

.skeleton-info {
  margin-bottom: 8px;
}

.skeleton-category {
  width: 80px;
  height: 12px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

.skeleton-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  width: 100%;
  min-height: 40px;
  max-height: 48px;
  margin: 0;
  line-height: 1.4;
}

.skeleton-title::before {
  content: '';
  display: block;
  width: 100%;
  height: 21px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 1.4px;
}

.skeleton-title::after {
  content: '';
  display: block;
  width: 70%;
  height: 21px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Mobile */
@media (max-width: 640px) {
  .skeleton-image {
    height: 120px;
  }

  .skeleton-content {
    padding: 10px;
  }

  .skeleton-title {
    min-height: 40px;
    max-height: 40px;
  }

  .skeleton-title::before,
  .skeleton-title::after {
    height: 19px;
  }

  .skeleton-category {
    width: 60px;
    height: 10px;
  }
}
</style>
